import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Button, Stack } from '@optimus-web/core';
import { useUpdateCurrentUserMutation } from '../../../queries/useUpdateCurrentUserMutation';
import { ContactInfo } from './ContactInfo';
import { PersonalInfo } from './PersonalInfo';
import { ProfileFormValues } from './types';
import { useProfileForm } from './useProfileForm';
import { ProfilePhoto } from './ProfilePhoto';

export interface ProfileFormProps {
    defaultValues: ProfileFormValues;
    isUserProvisioned: boolean;
}

const Form = ({ isLoading, isUserProvisioned }: { isLoading: boolean; isUserProvisioned: boolean }) => (
    <>
        {isUserProvisioned && (
            <Banner
                primaryText={<LocalizedText textKey={TextKey.UserManagementCannotEditProvisionedUserBannerTitle} />}
                secondaryText={<LocalizedText textKey={TextKey.UserManagementCannotEditProvisionedAccountBannerText} />}
                variant="info"
            />
        )}

        <ProfilePhoto />

        <PersonalInfo isUserProvisioned={isUserProvisioned} />

        <ContactInfo />

        <Stack alignment="end">
            <Button variant="primary" type="submit" loading={isLoading}>
                <LocalizedText textKey={TextKey.Save} />
            </Button>
        </Stack>
    </>
);

export const ProfileForm = ({ defaultValues, isUserProvisioned }: ProfileFormProps) => {
    const { isPending, mutate } = useUpdateCurrentUserMutation();

    const { renderFormContent } = useProfileForm({ defaultValues, onSubmit: mutate });

    return renderFormContent(
        <Stack spacing="500" vertical>
            <Form isLoading={isPending} isUserProvisioned={isUserProvisioned} />
        </Stack>
    );
};
